import React, { useRef } from "react";
import { InputRef, message, Table } from "antd";
import { useNavigate } from "react-router-dom";
import CustomerBookingTableColumn from "./CustomerBookingTableColumn";
import { BookingDto } from "shared/types";
import PATHS from "shared/constants/paths";
import { PAGE_SIZE } from "shared/constants";
import { translate } from "shared/languages";

interface BookingTableProps {
  bookings?: BookingDto[];
  isLoading: boolean;
  showSearchStaff?: boolean;
  /** Show who attended — for a package's booking list, which can hold several
   *  people's bookings once the package is shared. */
  showAttendee?: boolean;
  sortAscending?: boolean;
  /** A membership's own booking list: its Kredit column reads a dash. */
  membership?: boolean;
}

const CustomerBookingTable: React.FC<BookingTableProps> = ({
  bookings = [],
  isLoading,
  showSearchStaff = true,
  showAttendee = false,
  sortAscending = true,
  membership = false,
}) => {
  const navigate = useNavigate();
  const searchInput = useRef<InputRef>(null);

  const handleRowClick = (booking: BookingDto) => {
    // A booking whose schedule was deleted has no detail page to open — tell the
    // user instead of navigating to a dead schedule.
    if (booking.is_schedule_deleted) {
      message.info(translate("messages.schedule_deleted"));
      return;
    }
    navigate(
      `${PATHS.SCHEDULE}/${
        booking.schedule_id
      }?occurrence_timestamp=${encodeURIComponent(booking.schedule_date ?? "")}`,
    );
  };

  return (
    <Table
      rowKey="id"
      size="middle"
      dataSource={bookings}
      columns={CustomerBookingTableColumn({
        showSearchStaff,
        showAttendee,
        searchInput,
        sortAscending,
        membership,
      })}
      loading={isLoading}
      style={{ borderRadius: 50 }}
      pagination={{
        pageSize: PAGE_SIZE,
        showSizeChanger: false,
      }}
      onRow={(booking) => ({
        onClick: () => handleRowClick(booking),
        style: {
          cursor: booking.is_schedule_deleted ? "not-allowed" : "pointer",
        },
      })}
    />
  );
};

export default CustomerBookingTable;
